module.exports = __webpack_public_path__ + "media/images/nurture_growth-e7689be5c9d38c2418becbd48e685f22.png";